import { Audio, Images, Tweens } from '@abcya/abcya_phaser';
import ContainerUtils from '@abcya/abcya_phaser/src/js/Utils/GameObjects/ContainerUtils';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import { ADDITION } from '../gameParts';

export default class NumberTile extends Phaser.GameObjects.Container {
  static get STAR_REMOVED() {return 'STAR_REMOVED';}

  static get TILE_SELECTED() {return 'TILE_SELECTED';}

  constructor(scene, number, isDemo = false) {
    super(scene);
    this.sprite = null;
    this.number = null;
    this.rowNumber = 0;
    this.colNumber = 0;

    this.enabled = true;
    this.doAction = null;
    this.outline = null;
    this.outlineMask = null;
    this.selected = false;
    this.shadow = null;
    this.star = null;
    this.row = null;
    this.column = null;
    this.hasStar = false;
    this.startTime = null;
    this.ticker = null;
    this.totalSeconds = 0;
    this.starBlinking = false;
    this.starTimerRef = null;

    this.outlineColor = gameData.gameType === ADDITION ? 0xffc025 : 0x000000;

    this.number = number;

    this.sprite = Images.addImage(0, 0, 'brown_tile', this);

    this.textLabel = this.scene.add.text(this.sprite.x, this.sprite.y + 1, number, { fontFamily: FontKeys.odin, color: '#fff', fontSize: '60pt', align: 'center' }).setOrigin(.5);
    this.add(this.textLabel);

    if (!isDemo) {
      this.on('pointerdown', () => {this.doClick();});
      ContainerUtils.setContainerInteractive(this);
    }
  };

  addStar() {
    this.star = Images.addImage(0, 0, 'tile_star', this);
    this.star.x = this.sprite.width / 2 - this.star.width / 2;
    this.star.y = -1 * this.sprite.height / 2 + this.star.height / 2 - 1;

    this.hasStar = true;

    this.timer = this.scene.time.addEvent({ delay: 16000,
      callback: () => {
        this.blinkStar(9);
      } });

    this.on('BLINK_DONE', () => {
      this.hasStar = false;
      this.starBlinking = true;
      this.star.destroy();
      this.emit(NumberTile.STAR_REMOVED);
    });
  }

  stopStarTimer() {

    this.timer.paused = true;
    this.starBlinking = false;

  }

  blinkStar(times) {
    // 4 seconds of blinking
    if (this.star.scene) {

      Tweens.addTween(this.star, 10, { alpha: 0, completeDelay: 150 }, Phaser.Math.Easing.Quadratic.InOut, () => {
        if (!this.star.scene) return;

        Tweens.addTween(this.star, 10, { alpha: 1, completeDelay: 350 }, Phaser.Math.Easing.Quadratic.InOut, () => {
        // eslint-disable-next-line no-param-reassign
          times--;
          if (times !== 0 && this.starBlinking) {
            this.blinkStar(times);
          }
          else {
            this.emit('BLINK_DONE');
          }
        });
      });
    }
  }

  showLink(direction) {

    const linkWidth = 8;
    const linkLength = 20;

    switch (direction) {

      case 'north':
        this.linkNorth = this.scene.add.rectangle(
          -0.5 * linkWidth,
          (-1 * linkWidth - linkLength - this.sprite.getBounds().height / 2) + 1,
          linkWidth,
          linkLength,
          this.outlineColor,
          1
        ).setOrigin(0);

        this.add(this.linkNorth);

        break;

      case 'south':

        this.linkSouth = this.scene.add.rectangle(
          -0.5 * linkWidth,
          (linkWidth + this.sprite.getBounds().height / 2) - 1,
          linkWidth,
          linkLength,
          this.outlineColor,
          1
        ).setOrigin(0);

        this.add(this.linkSouth);

        break;

      case 'east':

        this.linkEast = this.scene.add.rectangle(
          (-1 * linkWidth - linkLength - this.sprite.getBounds().width / 2) + 1,
          -0.5 * linkWidth,
          linkLength,
          linkWidth,
          this.outlineColor,
          1
        ).setOrigin(0);
        this.add(this.linkEast);

        break;

      case 'west':

        this.linkWest = this.scene.add.rectangle(
          (linkWidth + this.sprite.getBounds().width / 2) - 1 ,
          -0.5 * linkWidth,
          linkLength,
          linkWidth,
          this.outlineColor,
          1
        ).setOrigin(0);
        this.add(this.linkWest);

        break;
    }
  }

  // timer functions

  turnOutlineOn() {

    this.selected = true;
    this.outline = this.scene.add.graphics();
    this.outline.fillStyle(this.outlineColor, 1);
    const topLeft = this.sprite.getTopLeft();
    this.outline.fillRoundedRect(topLeft.x - 8, topLeft.y - 8, this.sprite.width + 16, this.sprite.height + 16, 15);
    this.add(this.outline);

    this.sendToBack(this.outline);
  }

  deselect() {

    this.turnOutlineOff();
    this.remove(this.linkNorth, true);
    this.remove(this.linkSouth, true);
    this.remove(this.linkEast, true);
    this.remove(this.linkWest, true);

    this.linkNorth = null;
    this.linkSouth = null;
    this.linkEast = null;
    this.linkWest = null;

  }

  turnOutlineOff() {

    this.selected = false;

    this.remove(this.outline, true);

    this.outline = null;
  }

  appear() {

    this.alpha = 1;

    this.enabled = true;

    const cScaleX = this.scaleX;

    Audio.playOneShot('woosh', this.scene, 0.8);

    Tweens.addTween(this.sprite, 70, { scale: cScaleX * 0.8, yoyo: true, repeat: 2 }, Phaser.Math.Easing.Quadratic.InOut);

  }

  disappear() {

    this.deselect();

    // if a star is showing we need to animate star collected
    // and send event that bonus gained

    if (this.outline) this.outline.destroy();

    this.destroy();

  }

  doClick() {
    if (!this.enabled) { return; }

    Audio.playOneShot('click', this.scene);

    if (!this.selected) {
      this.turnOutlineOn();
    }
    else {

      this.deselect();
    }

    this.emit(NumberTile.TILE_SELECTED, this.number);

  };

  simulateClick() {

    if (!this.selected) {
      this.turnOutlineOn();
    }
    else {

      this.deselect();
    }

    this.emit(NumberTile.TILE_SELECTED, this.number);

  };

  setButtonOn() {

    this.enabled = true;
    this.buttonSprite.alpha = 1.0;

  };

  setButtonOff() {

    this.enabled = false;
    this.buttonSprite.alpha = 0.6;

  };
}